const SPA_RETURN_URL_STORAGE_PREFIX = 'spaPreviousNonSpaUrl:';

const getResortDirectory = (pathname) => {
  const pathParts = pathname.split('/').filter(Boolean);
  return pathParts[0] || '';
};

const isSpaPath = (pathname, resortDirectory) => {
  const spaRoot = `/${resortDirectory}/spa`;
  return pathname === spaRoot || pathname.startsWith(`${spaRoot}/`);
};

const isSameResortPath = (pathname, resortDirectory) => {
  const resortRoot = `/${resortDirectory}`;
  return pathname === resortRoot || pathname.startsWith(`${resortRoot}/`);
};

const storePreviousNonSpaUrl = () => {
  const { pathname, search, hash } = window.location;
  const resortDirectory = getResortDirectory(pathname);

  if (!resortDirectory) return;
  if (!isSameResortPath(pathname, resortDirectory)) return;
  if (isSpaPath(pathname, resortDirectory)) return;

  const storageKey = `${SPA_RETURN_URL_STORAGE_PREFIX}${resortDirectory}`;
  const currentPath = `${pathname}${search}${hash}`;

  try {
    sessionStorage.setItem(storageKey, currentPath);
  } catch (error) {
    // no-op
  }
};

if (typeof window !== 'undefined') {
  storePreviousNonSpaUrl();
}
